module.exports = __webpack_public_path__ + "static/media/A21_Diesel.48211de7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/A21_Diesel.jpg
// module id = 1485
// module chunks = 0